import React from 'react';
import { ErrorMessage } from 'formik';
import PropTypes from 'prop-types';

//components
import FormLabel from '../Label';
import { FormInput } from 'components/common';
import ErrorField from '../ErrorField';
//styles
import { FormGroup } from 'components/styled/Form.styled';

const EmailField = ({ name, label, error, pasteDisabled, isRequired, disabled }) => {
  return (
    <FormGroup>
      <FormLabel label={label} name={name} error={error} isRequired={isRequired} />
      <FormInput
        name={name}
        type="email"
        error={error}
        pasteDisabled={pasteDisabled}
        disabled={disabled}
      />
      <ErrorMessage name={name} component={ErrorField} />
    </FormGroup>
  );
};

EmailField.propTypes = {
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  pasteDisabled: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default EmailField;
